import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Pulizia immediata della cache 'api-cache' lasciata dal Service Worker
// precedente (pre-fix 58c2bd7), che cachava le risposte /api/ per 24h causando
// dati stantii (es. pulsante "Prendi in carico" errato su chiamate "da terminare").
// Eseguita lato pagina (API globale caches) prima del render, così la prima
// fetch delle API va sempre in rete e non serve un hard-reload manuale.
if ('caches' in window) {
  caches.keys().then((keys) => {
    keys.filter((k) => k === 'api-cache').forEach((k) => caches.delete(k))
  }).catch(() => {})
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
